var F={50:"#FFF3F0",100:"#FFF3F0",200:"#FFE7E2",300:"#FFC2B6",400:"#FE9882",500:"#FE866C",600:"#D8725C",700:"#B25E4C",800:"#7F4336"};export{F as default};
